import React from 'react';
import './kovin.css';

const ProfZakiAwgIsa  = () => {
  return (
    <div className="kovin-container">
      {/* Animated Header with Gradient */}
      <header className="kovin-header">
        {/* <div className="logo-container">
          <img src="/round-eyecare.webp" alt="Eye Care Institute Logo" className="logo logo-left" />
          <div className="logo-spacer"></div>
          <img src="/round-association.png" alt="Optometry Org Logo" className="logo logo-right" />
        </div> */}

        <div className="title-group">
          <div className="conference-meta">
            <h2 className="conference-location">1<sup>st</sup> International Optometric Conference</h2>
            <h2 className="conference-location">in Sri Lanka</h2>
            <h2 className="conference-year">Vision Beyond Borders – Advancing Global Eye Care</h2>
          </div>
          

        </div>
      </header>

      {/* Main Content Area */}
      <div className="content-section">
        {/* Decorative Elements */}
        <div className="decorative-elements">
          <div className="particle particle-1"></div>
          <div className="particle particle-2"></div>
          <div className="particle particle-3"></div>
          <img src="/lotus.png" alt="Lotus Tower" className="lotus-img" />
        </div>

        {/* Speaker Profile */}
        <div className="speaker-info">
          <div className="speaker-label-container">
            <h2 className="speaker-label">
              <span className="label-top">International</span>
              <span className="label-bottom">Speaker</span>
            </h2>
            <div className="label-decoration"></div>
          </div>

          <div className="profile-area">
            <div className="round-photo-container">
              <div className="round-photo">
                <img src="/Prof. M Zaki Awg Isa.jpg" alt="Prof. M Zaki Awg Isa" />
              </div>
              <div className="photo-ring"></div>
              <div className="photo-dots">
                {[...Array(12)].map((_, i) => <div key={i} className="dot"></div>)}
              </div>
            </div>
            
            <div className="name-bar">
              <h3>Prof. M Zaki Awg Isa</h3>
              <div className="name-underline"></div>
            </div>
          </div>

          <div className="bio-container">
            <p className="bio">

Prof. Mohd Zaki Awg Isa, PhD is a distinguished academic and specialist optometrist at Management and Science University 
(MSU). He currently serves as a Professor of Optometry and Director of the MSU Centre of Excellence for Vision & Eye Care 
(MSU-iCARE). Holding prestigious qualifications, including MCOptom (UK), he has made significant contributions to eye 
care education, clinical practice, and research.
<br /><br />

With extensive expertise spanning hospital eye care, business strategy, and change management, 
Prof. Zaki plays a vital role in advancing optometric services and leadership in the healthcare sector. 
His research interests focus on myopia management, occupational eye health, and community-based eye care 
initiatives, contributing meaningfully to both academic literature and public health impact.
<br /><br />

<div className="bio-container">
  <p className="bio">
    • Professor & Director: Professor of Optometry and Director of MSU-iCARE at <br />
      &nbsp; &nbsp;Management and Science University (MSU) <br />

    • Specialist Optometrist: Expertise in hospital eye care, business strategy, <br />
      &nbsp; &nbsp;and change management <br />

    • Research Focus: Myopia control, occupational eye health, and community <br />
      &nbsp; &nbsp;eye care programs <br />

    • Professional Leadership: Council Member of the Malaysian Optical Council <br />
      &nbsp; &nbsp;(MOC) (2023–2026) <br />

    • Active member of the Association of Malaysian Optometrists (AMO) <br />

    • Recognized internationally through scholarly publications indexed on <br />
      &nbsp; &nbsp;Google Scholar and ORCID <br />
  </p>
  <div className="bio-decoration"></div>
</div>

            </p>
            <div className="bio-decoration"></div>
          </div>
        </div>
      </div>

      {/* Footer with Conference Details */}
      <footer className="conference-footer">
        <div className="footer-details">
       <p className="date-venue">Registration Until 24<sup>th</sup> of January, 2026</p>
          <p className="register-cta">Register Now <span>&rarr;</span><a href="https://eyecare2026.com/payment">Click Here</a></p>
        </div>
      </footer>
    </div>
  );
};

export default ProfZakiAwgIsa